// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gmnPage {
  position: relative;
  width: 100%;
  min-height: calc(100vh - 76px);
  margin-top: 0 !important;
  padding: 0 0 32px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
}
.gmnHeader {
  box-sizing: border-box;
  display: flex;
  width: calc(100% + 48px);
  min-height: 112px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 11px;
  margin: -20px 0 18px -24px;
  padding: 14px 72px 14px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}
.gmnHeaderPrimary {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 17px;
}
.gmnHeaderCopy {
  min-width: 0;
}
.gmnHeader h1 {
  margin: 0;
  overflow: hidden;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gmnHeader p {
  display: flex;
  min-width: 0;
  align-items: baseline;
  gap: 8px;
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  line-height: 1.35;
}
.gmnHeader p strong {
  max-width: min(420px, 42vw);
  overflow: hidden;
  color: var(--text-body, #334155);
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gmnHeader p span::before {
  margin-right: 8px;
  color: var(--border-default, #cbd5e1);
  content: '·';
}
.gmnBack,
.gmnLink {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}
.gmnBack {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.gmnBack svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.gmnBack:hover,
.gmnLink:hover {
  color: var(--blue-600, #1a6da3);
  text-decoration: underline;
}
.gmnHeaderDivider {
  width: 1px;
  height: 42px;
  flex: none;
  background: var(--border-subtle, #e2e8f0);
}
.gmnHeaderChips {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  padding-left: 0;
}
.gmnSummaryChip {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  padding: 0 9px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 11px;
  font-weight: 750;
  line-height: 1;
  white-space: nowrap;
}
.gmnSummaryChip.is-status.is-sent,
.gmnSummaryChip.is-delivered {
  border-color: #cce9d8;
  background: #eaf7ef;
  color: #25784a;
}
.gmnSummaryChip.is-status.is-scheduled,
.gmnSummaryChip.is-scheduled,
.gmnSummaryChip.is-planned,
.gmnSummaryChip.is-pending {
  border-color: #f5d89f;
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}
.gmnSummaryChip.is-status.is-draft,
.gmnSummaryChip.is-count,
.gmnSummaryChip.is-sent-at {
  border-color: var(--border-subtle, #e2e8f0);
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
}
.gmnSummaryChip.is-channel {
  border-color: #cfe1f2;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}
.gmnSummaryChip.is-channel::before {
  width: 6px;
  height: 6px;
  margin-right: 6px;
  border-radius: 50%;
  background: currentColor;
  content: '';
}
.gmnSummaryChip.is-failed,
.gmnSummaryChip.is-unavailable {
  border-color: #f3ccd3;
  background: #fff0f2;
  color: #a8253a;
}
.gmnContentCard {
  box-sizing: border-box;
  width: 100%;
  padding: 16px;
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.gmnToolbar,
.gmnPagination {
  display: flex;
  width: 100%;
  max-width: none;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0;
}
.gmnToolbar {
  justify-content: flex-start;
}
.gmnToolbarControls {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}
.gmnToolbar > strong {
  color: #101828;
  font-size: 15px;
}
.gmnToolbar > strong span {
  display: inline-flex;
  min-width: 22px;
  height: 22px;
  margin-left: 6px;
  padding: 0 7px;
  border-radius: 999px;
  background: #eef2f6;
  color: #667085;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
}
.gmnSearch {
  position: relative;
  width: min(330px, 34vw);
  min-width: 220px;
}
.gmnSearch input {
  width: 100%;
  height: 38px;
  padding: 0 36px 0 11px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: #fff;
  color: var(--text-body, #334155);
  font-size: 13px;
  outline: none;
}
.gmnSearch input:focus {
  border-color: var(--blue-500, #227ebd);
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}
.gmnSearch input::-webkit-search-cancel-button {
  display: none;
}
.gmnSearch > button {
  position: absolute;
  top: 50%;
  right: 6px;
  display: inline-flex;
  width: 27px;
  height: 27px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 18px;
  line-height: 1;
  transform: translateY(-50%);
  cursor: pointer;
}
.gmnSearch > button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.gmnFilterButton,
.gmnButton {
  display: inline-flex;
  height: 38px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  color: #334155;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}
.gmnFilterButton:hover,
.gmnButton:hover {
  border-color: #9eb8cc;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.gmnFilterButton svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
}
.gmnButton svg {
  width: 17px;
  height: 17px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
}
.gmnButton.is-active {
  border-color: #6fb1df;
  background: #eef6fc;
  color: #155d8c;
}
.gmnButton > b {
  display: inline-flex;
  min-width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e9eef3;
  color: #475467;
  font-size: 10px;
}
.gmnRetryButton {
  border-color: #b9d9ee;
  background: #eef6fc;
  color: #155d8c;
}
.gmnRetryButton:disabled {
  cursor: wait;
  opacity: 0.65;
}
.gmnRetryNotice {
  max-width: none;
  margin: 12px 0 0;
  padding: 10px 12px;
  border: 1px solid #cfe2ef;
  border-radius: 8px;
  background: #eef6fc;
  color: #155d8c;
  font-size: 12.5px;
  font-weight: 600;
}
.gmnRetryNotice.is-error {
  border-color: #f4c9d0;
  background: #fff1f3;
  color: #a8253a;
}
.gmnFilterButton.is-active {
  border-color: #6fb1df;
  background: #eef6fc;
  color: #155d8c;
}
.gmnFilterButton b {
  display: inline-flex;
  min-width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #227ebd;
  color: #fff;
  font-size: 10px;
}
.gmnColumns {
  position: relative;
}
.gmnColumnsMenu {
  position: absolute;
  z-index: 120;
  top: calc(100% + 7px);
  right: 0;
  width: 230px;
  padding: 10px;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.18);
}
.gmnColumnsMenu header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 4px 9px;
  border-bottom: 1px solid #eaecf0;
  color: #344054;
  font-size: 12px;
}
.gmnColumnsMenu header button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1b678f;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}
.gmnColumnsMenu label {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 3px 0 0;
  padding: 7px 5px;
  border-radius: 7px;
  color: #475467;
  font-size: 12px;
  cursor: pointer;
}
.gmnColumnsMenu label:hover {
  background: #f5f8fb;
}
.gmnColumnsMenu input {
  width: 15px;
  height: 15px;
  margin: 0;
  accent-color: #227ebd;
}
.gmnFilter {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: auto;
  z-index: 1200;
  display: flex;
  width: min(360px, calc(100vw - 20px));
  flex-direction: column;
  gap: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  border: 0;
  border-left: 1px solid #d9e2ec;
  border-radius: 0;
  background: #fff;
  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);
}
.gmnFilter > header {
  display: flex;
  min-height: 64px;
  flex: none;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 18px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: #fff;
}
.gmnFilter > header strong {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 18px;
  font-weight: 800;
}
.gmnFilter > header button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.gmnFilter > header button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.gmnFilter__body {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 14px;
  padding: 18px 18px 24px;
  overflow-x: hidden;
  overflow-y: auto;
}
.gmnFilter label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
}
.gmnFilter label > span {
  color: #475467;
  font-size: 12px;
  font-weight: 700;
}
.gmnFilterChoices {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.gmnFilterChoices legend {
  margin: 0 0 8px;
  padding: 0;
  color: #475467;
  font-size: 12px;
  font-weight: 700;
}
.gmnFilterChoices > div {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
}
.gmnFilterChoices button {
  min-height: 30px;
  padding: 0 11px;
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  background: #fff;
  color: #475467;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}
.gmnFilterChoices button:hover {
  border-color: #9eb8cc;
  background: #f7fafc;
  color: #1d4f70;
}
.gmnFilterChoices button.is-selected {
  border-color: #72add3;
  background: #eaf3fb;
  color: #155d8c;
  box-shadow: inset 0 0 0 1px rgba(34, 126, 189, 0.08);
}
.gmnFilter input,
.gmnFilter select {
  width: 100%;
  height: 38px;
  padding: 0 10px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font-size: 13px;
  font-weight: 400;
  outline: none;
}
.gmnFilter input:focus,
.gmnFilter select:focus {
  border-color: #6fb1df;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}
.gmnFilterActions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding: 14px 18px;
  border-top: 1px solid #e5e9f0;
  background: #fff;
}
.gmnFilterActions > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.gmnButton--primary {
  border-color: var(--blue-500, #227ebd);
  background: var(--blue-500, #227ebd);
  color: #fff;
}
.gmnButton--primary:hover {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
  color: #fff;
}
.gmnChips {
  display: flex;
  min-height: 45px;
  max-width: none;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin: 10px 0 0;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}
.gmnChips > span {
  display: inline-flex;
  min-height: 27px;
  align-items: center;
  gap: 6px;
  padding: 0 9px;
  border-radius: 999px;
  background: #eaf3fb;
  color: #1c5d8c;
  font-size: 11.5px;
  font-weight: 700;
}
.gmnChips > span button {
  display: inline-flex;
  width: 19px;
  height: 19px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: inherit;
  font-size: 15px;
  cursor: pointer;
}
.gmnChips > span button:hover {
  background: rgba(21, 93, 140, 0.1);
}
.gmnTableCard {
  max-width: none;
  margin: 14px 0 0;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: #fff;
}
.gmnTableCard table {
  width: 100%;
  min-width: 1040px;
  border-collapse: collapse;
}
.gmnTableCard th {
  height: 42px;
  padding: 0 14px;
  border-bottom: 1px solid #e4e7ec;
  background: #f8fafc;
  color: #667085;
  font-size: 11px;
  font-weight: 800;
  text-align: left;
  text-transform: uppercase;
}
.gmnTableCard td {
  padding: 13px 14px;
  border-bottom: 1px solid #eef2f6;
  font-size: 13px;
  vertical-align: middle;
}
.gmnTableCard td strong,
.gmnTableCard td span {
  display: block;
}
.gmnTableCard td > span {
  margin-top: 3px;
  color: #667085;
  font-size: 11.5px;
}
.gmnContacts {
  display: flex;
  min-width: 160px;
  flex-direction: column;
  gap: 5px;
}
.gmnContacts span {
  display: flex !important;
  align-items: baseline;
}
.gmnContacts a {
  color: #344054;
  font-size: 11.5px;
  text-decoration: none;
}
.gmnContacts a:hover {
  color: #155d8c;
  text-decoration: underline;
}
.gmnNoContact {
  color: #98a2b3 !important;
}
.gmnStatuses {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
}
.gmnLoadingBar {
  padding: 8px 14px;
  border-bottom: 1px solid #d9e7f2;
  background: #eef7fd;
  color: #315f7c;
  font-size: 12px;
  font-weight: 600;
}
.gmnStatusGroup {
  display: flex;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}
.gmnSuppressionReason {
  max-width: 420px;
  color: #667085;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
}
.gmnStatuses span {
  display: inline-flex !important;
  min-height: 27px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 9px;
  border-radius: 999px;
  background: #eef2f6;
  color: #475467;
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1;
}
.gmnStatuses span i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}
.gmnStatuses span b {
  text-transform: capitalize;
}
.gmnStatuses .is-delivered,
.gmnStatuses .is-sent {
  background: #e8f6ee;
  color: #25784a;
}
.gmnStatuses .is-failed {
  background: #fdecef;
  color: #a8253a;
}
.gmnStatuses .is-unavailable {
  background: #eef2f6;
  color: #667788;
}
.gmnStatuses .is-pending,
.gmnStatuses .is-warning {
  background: #fdf3e0;
  color: #b77912;
}
.gmnRole {
  display: inline-flex !important;
  min-height: 22px;
  align-items: center;
  padding: 0 8px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #334155 !important;
  font-size: 11px !important;
  font-weight: 700;
  text-transform: uppercase;
}
.gmnRole--parent {
  background: #f3ecfb;
  color: #7850a6 !important;
}
.gmnRole--student {
  background: #eaf3fb;
  color: #1c5d8c !important;
}
.gmnRole--teacher,
.gmnRole--coach,
.gmnRole--manager,
.gmnRole--admin {
  background: #eaf6ee;
  color: #287a4d !important;
}
.gmnEmpty {
  padding: 44px 20px;
  color: #667085;
  font-size: 13px;
  text-align: center;
}
.gmnPagination {
  justify-content: flex-end;
  margin-top: 14px;
  color: #667085;
  font-size: 12px;
}
.gmnPagination > span {
  margin-right: auto;
  font-weight: 650;
}
.gmnPagination > div {
  display: flex;
  align-items: center;
  gap: 7px;
}
.gmnPagination button,
.gmnPagination b {
  display: inline-flex;
  min-width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #475467;
  font-size: 12px;
}
.gmnPagination button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.gmnPaginationModern {
  margin-top: 14px;
}

.gmnPaginationModern .bPagination--modern {
  margin: 0;
}
@media (max-width: 1217px) {
  .gmnHeader {
    width: 100vw;
    margin-left: -12px;
    padding-right: 28px;
  }
}
@media (max-width: 760px) {
  .gmnPage {
    padding: 0 0 24px;
  }
  .gmnHeader {
    width: 100vw;
    min-height: 0;
    gap: 10px;
    margin: -16px 0 14px -16px;
    padding: 14px 16px;
  }
  .gmnHeaderPrimary {
    width: 100%;
    align-items: flex-start;
    gap: 10px;
  }
  .gmnHeaderDivider {
    height: 38px;
  }
  .gmnHeader h1 {
    font-size: 20px;
  }
  .gmnHeader p {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
  .gmnHeader p strong {
    max-width: calc(100vw - 155px);
  }
  .gmnHeader p span::before {
    display: none;
  }
  .gmnHeaderChips {
    width: 100%;
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 2px;
  }
  .gmnContentCard {
    padding: 12px;
    border-radius: 10px;
  }
  .gmnToolbar {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .gmnToolbar > strong {
    width: 100%;
  }
  .gmnToolbarControls {
    width: 100%;
    align-items: stretch;
    flex-wrap: wrap;
  }
  .gmnSearch {
    width: 100%;
    min-width: 0;
    flex: 1 0 100%;
  }
  .gmnFilter {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: auto;
    width: min(360px, 100%);
    max-height: none;
    overflow: auto;
    border-radius: 0;
  }
  .gmnFilterActions {
    background: #fff;
  }
  .gmnTableCard {
    overflow-x: auto;
  }
  .gmnTableCard table {
    min-width: 760px;
  }
  .gmnPagination {
    align-items: flex-start;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Communications/GeneralMessages/GeneralMessageNotifications/GeneralMessageNotifications.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,wBAAwB;EACxB,iBAAiB;EACjB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,0BAA0B;EAC1B,4BAA4B;EAC5B,sDAAsD;EACtD,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,YAAY;AACd;AACA;;EAEE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;AACA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;EACpB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;EACrB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;EAGE,2CAA2C;EAC3C,0CAA0C;EAC1C,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;AACb;AACA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;AAC9C;AACA;;EAEE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,SAAS;AACX;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,aAAa;AACf;AACA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,qBAAqB;EACrB,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,aAAa;EACb,qCAAqC;EACrC,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,eAAe;EACf,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,oDAAoD;AACtD;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sDAAsD;AACxD;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;;;;EAIE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;AACA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;IACT,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;EACA;IACE,8BAA8B;EAChC;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;EACA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".gmnPage {\n  position: relative;\n  width: 100%;\n  min-height: calc(100vh - 76px);\n  margin-top: 0 !important;\n  padding: 0 0 32px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n}\n.gmnHeader {\n  box-sizing: border-box;\n  display: flex;\n  width: calc(100% + 48px);\n  min-height: 112px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 11px;\n  margin: -20px 0 18px -24px;\n  padding: 14px 72px 14px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n.gmnHeaderPrimary {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 17px;\n}\n.gmnHeaderCopy {\n  min-width: 0;\n}\n.gmnHeader h1 {\n  margin: 0;\n  overflow: hidden;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.015em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gmnHeader p {\n  display: flex;\n  min-width: 0;\n  align-items: baseline;\n  gap: 8px;\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  line-height: 1.35;\n}\n.gmnHeader p strong {\n  max-width: min(420px, 42vw);\n  overflow: hidden;\n  color: var(--text-body, #334155);\n  font-weight: 700;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.gmnHeader p span::before {\n  margin-right: 8px;\n  color: var(--border-default, #cbd5e1);\n  content: '·';\n}\n.gmnBack,\n.gmnLink {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.gmnBack {\n  display: inline-flex;\n  flex: none;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n.gmnBack svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.gmnBack:hover,\n.gmnLink:hover {\n  color: var(--blue-600, #1a6da3);\n  text-decoration: underline;\n}\n.gmnHeaderDivider {\n  width: 1px;\n  height: 42px;\n  flex: none;\n  background: var(--border-subtle, #e2e8f0);\n}\n.gmnHeaderChips {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n  padding-left: 0;\n}\n.gmnSummaryChip {\n  display: inline-flex;\n  min-height: 25px;\n  align-items: center;\n  padding: 0 9px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 11px;\n  font-weight: 750;\n  line-height: 1;\n  white-space: nowrap;\n}\n.gmnSummaryChip.is-status.is-sent,\n.gmnSummaryChip.is-delivered {\n  border-color: #cce9d8;\n  background: #eaf7ef;\n  color: #25784a;\n}\n.gmnSummaryChip.is-status.is-scheduled,\n.gmnSummaryChip.is-scheduled,\n.gmnSummaryChip.is-planned,\n.gmnSummaryChip.is-pending {\n  border-color: #f5d89f;\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n.gmnSummaryChip.is-status.is-draft,\n.gmnSummaryChip.is-count,\n.gmnSummaryChip.is-sent-at {\n  border-color: var(--border-subtle, #e2e8f0);\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n}\n.gmnSummaryChip.is-channel {\n  border-color: #cfe1f2;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n.gmnSummaryChip.is-channel::before {\n  width: 6px;\n  height: 6px;\n  margin-right: 6px;\n  border-radius: 50%;\n  background: currentColor;\n  content: '';\n}\n.gmnSummaryChip.is-failed,\n.gmnSummaryChip.is-unavailable {\n  border-color: #f3ccd3;\n  background: #fff0f2;\n  color: #a8253a;\n}\n.gmnContentCard {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 16px;\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n.gmnToolbar,\n.gmnPagination {\n  display: flex;\n  width: 100%;\n  max-width: none;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0;\n}\n.gmnToolbar {\n  justify-content: flex-start;\n}\n.gmnToolbarControls {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 8px;\n}\n.gmnToolbar > strong {\n  color: #101828;\n  font-size: 15px;\n}\n.gmnToolbar > strong span {\n  display: inline-flex;\n  min-width: 22px;\n  height: 22px;\n  margin-left: 6px;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #667085;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 800;\n}\n.gmnSearch {\n  position: relative;\n  width: min(330px, 34vw);\n  min-width: 220px;\n}\n.gmnSearch input {\n  width: 100%;\n  height: 38px;\n  padding: 0 36px 0 11px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  outline: none;\n}\n.gmnSearch input:focus {\n  border-color: var(--blue-500, #227ebd);\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n.gmnSearch input::-webkit-search-cancel-button {\n  display: none;\n}\n.gmnSearch > button {\n  position: absolute;\n  top: 50%;\n  right: 6px;\n  display: inline-flex;\n  width: 27px;\n  height: 27px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 18px;\n  line-height: 1;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.gmnSearch > button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.gmnFilterButton,\n.gmnButton {\n  display: inline-flex;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 0 12px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  color: #334155;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.gmnFilterButton:hover,\n.gmnButton:hover {\n  border-color: #9eb8cc;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.gmnFilterButton svg {\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n}\n.gmnButton svg {\n  width: 17px;\n  height: 17px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.7;\n}\n.gmnButton.is-active {\n  border-color: #6fb1df;\n  background: #eef6fc;\n  color: #155d8c;\n}\n.gmnButton > b {\n  display: inline-flex;\n  min-width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: #e9eef3;\n  color: #475467;\n  font-size: 10px;\n}\n.gmnRetryButton {\n  border-color: #b9d9ee;\n  background: #eef6fc;\n  color: #155d8c;\n}\n.gmnRetryButton:disabled {\n  cursor: wait;\n  opacity: 0.65;\n}\n.gmnRetryNotice {\n  max-width: none;\n  margin: 12px 0 0;\n  padding: 10px 12px;\n  border: 1px solid #cfe2ef;\n  border-radius: 8px;\n  background: #eef6fc;\n  color: #155d8c;\n  font-size: 12.5px;\n  font-weight: 600;\n}\n.gmnRetryNotice.is-error {\n  border-color: #f4c9d0;\n  background: #fff1f3;\n  color: #a8253a;\n}\n.gmnFilterButton.is-active {\n  border-color: #6fb1df;\n  background: #eef6fc;\n  color: #155d8c;\n}\n.gmnFilterButton b {\n  display: inline-flex;\n  min-width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 10px;\n}\n.gmnColumns {\n  position: relative;\n}\n.gmnColumnsMenu {\n  position: absolute;\n  z-index: 120;\n  top: calc(100% + 7px);\n  right: 0;\n  width: 230px;\n  padding: 10px;\n  border: 1px solid #d0d5dd;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 14px 35px rgba(15, 23, 42, 0.18);\n}\n.gmnColumnsMenu header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 3px 4px 9px;\n  border-bottom: 1px solid #eaecf0;\n  color: #344054;\n  font-size: 12px;\n}\n.gmnColumnsMenu header button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #1b678f;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n.gmnColumnsMenu label {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  margin: 3px 0 0;\n  padding: 7px 5px;\n  border-radius: 7px;\n  color: #475467;\n  font-size: 12px;\n  cursor: pointer;\n}\n.gmnColumnsMenu label:hover {\n  background: #f5f8fb;\n}\n.gmnColumnsMenu input {\n  width: 15px;\n  height: 15px;\n  margin: 0;\n  accent-color: #227ebd;\n}\n.gmnFilter {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: auto;\n  z-index: 1200;\n  display: flex;\n  width: min(360px, calc(100vw - 20px));\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  border: 0;\n  border-left: 1px solid #d9e2ec;\n  border-radius: 0;\n  background: #fff;\n  box-shadow: -12px 0 34px rgba(15, 23, 42, 0.14);\n}\n.gmnFilter > header {\n  display: flex;\n  min-height: 64px;\n  flex: none;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 0 18px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fff;\n}\n.gmnFilter > header strong {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 18px;\n  font-weight: 800;\n}\n.gmnFilter > header button {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 22px;\n  line-height: 1;\n  cursor: pointer;\n}\n.gmnFilter > header button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.gmnFilter__body {\n  display: flex;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 14px;\n  padding: 18px 18px 24px;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n.gmnFilter label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0;\n}\n.gmnFilter label > span {\n  color: #475467;\n  font-size: 12px;\n  font-weight: 700;\n}\n.gmnFilterChoices {\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.gmnFilterChoices legend {\n  margin: 0 0 8px;\n  padding: 0;\n  color: #475467;\n  font-size: 12px;\n  font-weight: 700;\n}\n.gmnFilterChoices > div {\n  display: flex;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n.gmnFilterChoices button {\n  min-height: 30px;\n  padding: 0 11px;\n  border: 1px solid #d0d5dd;\n  border-radius: 999px;\n  background: #fff;\n  color: #475467;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.gmnFilterChoices button:hover {\n  border-color: #9eb8cc;\n  background: #f7fafc;\n  color: #1d4f70;\n}\n.gmnFilterChoices button.is-selected {\n  border-color: #72add3;\n  background: #eaf3fb;\n  color: #155d8c;\n  box-shadow: inset 0 0 0 1px rgba(34, 126, 189, 0.08);\n}\n.gmnFilter input,\n.gmnFilter select {\n  width: 100%;\n  height: 38px;\n  padding: 0 10px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #344054;\n  font-size: 13px;\n  font-weight: 400;\n  outline: none;\n}\n.gmnFilter input:focus,\n.gmnFilter select:focus {\n  border-color: #6fb1df;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n.gmnFilterActions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n  padding: 14px 18px;\n  border-top: 1px solid #e5e9f0;\n  background: #fff;\n}\n.gmnFilterActions > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.gmnButton--primary {\n  border-color: var(--blue-500, #227ebd);\n  background: var(--blue-500, #227ebd);\n  color: #fff;\n}\n.gmnButton--primary:hover {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n  color: #fff;\n}\n.gmnChips {\n  display: flex;\n  min-height: 45px;\n  max-width: none;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin: 10px 0 0;\n  padding: 8px 0;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n.gmnChips > span {\n  display: inline-flex;\n  min-height: 27px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: #eaf3fb;\n  color: #1c5d8c;\n  font-size: 11.5px;\n  font-weight: 700;\n}\n.gmnChips > span button {\n  display: inline-flex;\n  width: 19px;\n  height: 19px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: inherit;\n  font-size: 15px;\n  cursor: pointer;\n}\n.gmnChips > span button:hover {\n  background: rgba(21, 93, 140, 0.1);\n}\n.gmnTableCard {\n  max-width: none;\n  margin: 14px 0 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: #fff;\n}\n.gmnTableCard table {\n  width: 100%;\n  min-width: 1040px;\n  border-collapse: collapse;\n}\n.gmnTableCard th {\n  height: 42px;\n  padding: 0 14px;\n  border-bottom: 1px solid #e4e7ec;\n  background: #f8fafc;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 800;\n  text-align: left;\n  text-transform: uppercase;\n}\n.gmnTableCard td {\n  padding: 13px 14px;\n  border-bottom: 1px solid #eef2f6;\n  font-size: 13px;\n  vertical-align: middle;\n}\n.gmnTableCard td strong,\n.gmnTableCard td span {\n  display: block;\n}\n.gmnTableCard td > span {\n  margin-top: 3px;\n  color: #667085;\n  font-size: 11.5px;\n}\n.gmnContacts {\n  display: flex;\n  min-width: 160px;\n  flex-direction: column;\n  gap: 5px;\n}\n.gmnContacts span {\n  display: flex !important;\n  align-items: baseline;\n}\n.gmnContacts a {\n  color: #344054;\n  font-size: 11.5px;\n  text-decoration: none;\n}\n.gmnContacts a:hover {\n  color: #155d8c;\n  text-decoration: underline;\n}\n.gmnNoContact {\n  color: #98a2b3 !important;\n}\n.gmnStatuses {\n  display: flex;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n.gmnLoadingBar {\n  padding: 8px 14px;\n  border-bottom: 1px solid #d9e7f2;\n  background: #eef7fd;\n  color: #315f7c;\n  font-size: 12px;\n  font-weight: 600;\n}\n.gmnStatusGroup {\n  display: flex;\n  max-width: 100%;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 5px;\n}\n.gmnSuppressionReason {\n  max-width: 420px;\n  color: #667085;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n}\n.gmnStatuses span {\n  display: inline-flex !important;\n  min-height: 27px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: #eef2f6;\n  color: #475467;\n  font-size: 10.5px;\n  font-weight: 700;\n  line-height: 1;\n}\n.gmnStatuses span i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n}\n.gmnStatuses span b {\n  text-transform: capitalize;\n}\n.gmnStatuses .is-delivered,\n.gmnStatuses .is-sent {\n  background: #e8f6ee;\n  color: #25784a;\n}\n.gmnStatuses .is-failed {\n  background: #fdecef;\n  color: #a8253a;\n}\n.gmnStatuses .is-unavailable {\n  background: #eef2f6;\n  color: #667788;\n}\n.gmnStatuses .is-pending,\n.gmnStatuses .is-warning {\n  background: #fdf3e0;\n  color: #b77912;\n}\n.gmnRole {\n  display: inline-flex !important;\n  min-height: 22px;\n  align-items: center;\n  padding: 0 8px;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #334155 !important;\n  font-size: 11px !important;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.gmnRole--parent {\n  background: #f3ecfb;\n  color: #7850a6 !important;\n}\n.gmnRole--student {\n  background: #eaf3fb;\n  color: #1c5d8c !important;\n}\n.gmnRole--teacher,\n.gmnRole--coach,\n.gmnRole--manager,\n.gmnRole--admin {\n  background: #eaf6ee;\n  color: #287a4d !important;\n}\n.gmnEmpty {\n  padding: 44px 20px;\n  color: #667085;\n  font-size: 13px;\n  text-align: center;\n}\n.gmnPagination {\n  justify-content: flex-end;\n  margin-top: 14px;\n  color: #667085;\n  font-size: 12px;\n}\n.gmnPagination > span {\n  margin-right: auto;\n  font-weight: 650;\n}\n.gmnPagination > div {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n.gmnPagination button,\n.gmnPagination b {\n  display: inline-flex;\n  min-width: 34px;\n  height: 34px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  border: 1px solid #d0d5dd;\n  border-radius: 8px;\n  background: #fff;\n  color: #475467;\n  font-size: 12px;\n}\n.gmnPagination button:disabled {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.gmnPaginationModern {\n  margin-top: 14px;\n}\n\n.gmnPaginationModern .bPagination--modern {\n  margin: 0;\n}\n@media (max-width: 1217px) {\n  .gmnHeader {\n    width: 100vw;\n    margin-left: -12px;\n    padding-right: 28px;\n  }\n}\n@media (max-width: 760px) {\n  .gmnPage {\n    padding: 0 0 24px;\n  }\n  .gmnHeader {\n    width: 100vw;\n    min-height: 0;\n    gap: 10px;\n    margin: -16px 0 14px -16px;\n    padding: 14px 16px;\n  }\n  .gmnHeaderPrimary {\n    width: 100%;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  .gmnHeaderDivider {\n    height: 38px;\n  }\n  .gmnHeader h1 {\n    font-size: 20px;\n  }\n  .gmnHeader p {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 2px;\n  }\n  .gmnHeader p strong {\n    max-width: calc(100vw - 155px);\n  }\n  .gmnHeader p span::before {\n    display: none;\n  }\n  .gmnHeaderChips {\n    width: 100%;\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    padding-bottom: 2px;\n  }\n  .gmnContentCard {\n    padding: 12px;\n    border-radius: 10px;\n  }\n  .gmnToolbar {\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n  .gmnToolbar > strong {\n    width: 100%;\n  }\n  .gmnToolbarControls {\n    width: 100%;\n    align-items: stretch;\n    flex-wrap: wrap;\n  }\n  .gmnSearch {\n    width: 100%;\n    min-width: 0;\n    flex: 1 0 100%;\n  }\n  .gmnFilter {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: auto;\n    width: min(360px, 100%);\n    max-height: none;\n    overflow: auto;\n    border-radius: 0;\n  }\n  .gmnFilterActions {\n    background: #fff;\n  }\n  .gmnTableCard {\n    overflow-x: auto;\n  }\n  .gmnTableCard table {\n    min-width: 760px;\n  }\n  .gmnPagination {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
